if (!customElements.get('lumerune-announcement-carousel')) {
  customElements.define('lumerune-announcement-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-announcement-slide]')];
      if (this.slides.length < 2 || this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.viewport = this.querySelector('.lr-announcements__viewport');
      this.pauseButton = this.querySelector('[data-announcement-pause]');
      this.querySelector('[data-announcement-prev]').addEventListener('click', () => this.move(-1, true), options);
      this.querySelector('[data-announcement-next]').addEventListener('click', () => this.move(1, true), options);
      this.pauseButton?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.schedule();
      }, options);
      this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => { queueMicrotask(() => this.schedule()); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reduced.addEventListener('change', () => { this.updatePause(); this.schedule(); }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index < 0) return;
        this.paused = true;
        this.updatePause();
        this.move(index - this.index, true);
      }, options);
      this.updatePause();
      this.schedule();
    }

    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.hidden = this.reduced.matches;
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Play announcements' : 'Pause announcements');
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.querySelector('[data-pause-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
    }

    move(direction, manual = false) {
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      this.viewport.setAttribute('aria-live', manual ? 'polite' : 'off');
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.dataset.autoplay !== 'true' || this.paused || this.hovered ||
          this.reduced.matches || document.hidden || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.move(1), Number(this.dataset.interval) || 6000);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      this.events = null;
    }
  });
}
